import { useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Popover,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Cancel,
  Edit,
  Info,
  KeyboardArrowRight,
  QrCode,
} from "@mui/icons-material";

import QRCode from "react-qr-code";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { useDispatch } from "react-redux";
import { openModal } from "../../store/actions/modalAction";
import { CenteredBox } from "../../components/layouts/common/boxes";

export const QrCodeModal = ({ name, id }) => {
  return (
    //  <CustomDialog
    //     id={'patient-qr'}

    //     // title={name + "'s Qr Code"}
    //     closeText="Close"
    // >
    // <CenteredBox sx={{flexDirection:"row"}} >
    <>
      <Stack
        direction={"row"}
        sx={{ display: "flex", alignItems: "center" }}
        mt={2}
        spacing={4}
      >
        <QRCode
          size={90}
          style={{ height: "auto", maxWidth: "100%" }}
          value={id}
          viewBox={`0 0 100 100`}
        />
        <Typography
          variant="h5"
          color="grey"
          fontWeight={500}
          sx={{ width: "100px" }}
        >
          Scan QR code to login in the app
        </Typography>
      </Stack>
    </>
    // </CenteredBox>
  );
  // </CustomDialog>
};

export const QrCodeButton = ({ params }) => {
  const dispatch = useDispatch();
  const handleClick = (event) => {
    dispatch(
      openModal(
        <QrCodeModal
          name={params.first_name + " " + params.last_name}
          id={params._id}
        />,
        "xs",
        undefined,
        "patient-qr"
      )
    );
  };

  return (
    <>
      <Tooltip title="view Qr Code">
        <IconButton
          variant="contained"
          sx={{ padding: 0 }}
          onClick={handleClick}
        >
          <QrCode />
        </IconButton>
      </Tooltip>
    </>
  );
};
